export var isNil = function isNil(value) {
  return value === undefined || value === null;
};
export var isNull = function isNull(value) {
  return value === null;
};
export var isPositiveNumber = function isPositiveNumber(value) {
  return value > 0;
};